<template>
  <OptionSummary></OptionSummary>
  <section class="members-banner-section">
    <videoBanner
      :videoObj="themeInfo.info?.videoBanners?.employersPage"
      :displayStyle="'employersPage'"
      v-if="themeInfo.info?.videoBanners?.employersPage"
    />
    <SellerBanner :pageName="'showInMembersPage'" v-else></SellerBanner>
  </section>
  <FullWidthText
    v-if="themeInfo.info?.business?.about"
    title="درباره ما"
    :text="themeInfo.info?.business?.about"
  />
  <div class="member-list-section" id="member-list-section">
    <div class="title">
      <h2>اعضاء</h2>
      <hr class="title-separator" />
    </div>
    <MemberCard
      :employer="newEmployer"
      :token="token"
      v-if="managerMode == 'dataEdit'"
    ></MemberCard>
    <template
      v-for="(employer, index) in themeInfo.info?.employers"
      :key="index"
    >
      <MemberCard :employer="employer" :token="token"></MemberCard>
    </template>
  </div>
</template>

<script>
import OptionSummary from "@/components/OptionSummary/index.vue";
import MemberCard from "@/components/MemberCard/index.vue";
import { membersData } from "@/repo/membersData";
import { mapGetters } from "vuex";
import { publicHelpers } from "@/public/helpers";
import SellerBanner from "@/components/SellerBanner/index.vue";
import videoBanner from "@/components/videoBanner/index.vue";
import FullWidthText from "@/components/fullWidthText/index.vue";
export default {
  name: "MembersPage",
  components: {
    OptionSummary,
    MemberCard,
    SellerBanner,
    videoBanner,
    FullWidthText,
  },
  mixins: [membersData, publicHelpers],
  data() {
    return {
      token: null,
    };
  },
  async mounted() {
    await this.$nextTick();
    this.token = this.$route.params.token;
  },
  computed: {
    ...mapGetters({
      themeInfo: "theme/themeInfo",
      managerMode: "managerMode",
    }),
  },
};
</script>

<style lang="css" scoped>
@import url(@/assets/style/pages/members/members.css);
</style>